import React, { useState, useEffect, useCallback } from "react";

import { useGetExactDocumentsMutation } from "../../../store/api/lumi/documents";
import { useGetLLMPassThroughMutation } from "../../../store/api/lumi/llm";
import SummaryHeader from "../../Summary/SummaryHeader";
import SummaryDocuments from "../../Summary/SummaryDocuments";
import SummaryText from "../../Summary/SummaryText";
import SummaryContainer from "../../Summary/SummaryContainer";

const VolumeSummary = ({ id, selectedConcept }) => {
    const [triggerGetDocuments] = useGetExactDocumentsMutation();
    const [triggerGetLLMPassThrough] = useGetLLMPassThroughMutation();

    const [conceptDocuments, setConceptDocuments] = useState([]);
    const [loadingConceptDocuments, setLoadingConceptDocuments] = useState([]);

    const [conceptSummary, setConceptSummary] = useState(null);
    const [loadingConceptSummary, setLoadingConceptSummary] = useState(false);

    const fetchDocuments = useCallback(async () => {
        setLoadingConceptDocuments(true);
        try {
            const result = await triggerGetDocuments({
                id,
                filter: [],
                search: selectedConcept.texts,
            }).unwrap();

            setConceptDocuments(result);
        } catch (error) {
            console.error("Failed to fetch documents:", error);

            setConceptDocuments([]);
        } finally {
            setLoadingConceptDocuments(false);
        }
    }, [triggerGetDocuments, id, selectedConcept]);

    useEffect(() => {
        if (selectedConcept)
        fetchDocuments();
    }, [selectedConcept]);

    const handleLlmRequest = useCallback(
        async (prompt) => {
            try {
                const llmResponse = await triggerGetLLMPassThrough({
                    projectId: id,
                    prompt: prompt,
                }).unwrap();

                return llmResponse.response;
            } catch (error) {
                console.error("failed to fetch summary", error);
                return null;
            }
        },
        [id, prompt]
    );

    const fetchSummary = useCallback(async () => {
        if (!selectedConcept) return;

        setLoadingConceptSummary(true);
        try {
            const prompt =
                `Summarize how "${selectedConcept.texts.join(", ")}" is spoken about in these documents\n` +
                conceptDocuments.map((d) => `<p>${d.text}</p>`).join("");

            const summary = await handleLlmRequest(prompt);
            setConceptSummary(summary);
        } catch (error) {
            console.error("Failed to fetch summaries:", error);
        } finally {
            setLoadingConceptSummary(false);
        }
    }, [conceptDocuments, handleLlmRequest]);

    useEffect(() => {
        fetchSummary();
    }, [conceptDocuments]);

    if (!selectedConcept)
        return (
            <SummaryContainer>
                <SummaryHeader>
                    Select a concept to show detailed summary.
                </SummaryHeader>
            </SummaryContainer>
        );

    return (
        <>
            <SummaryText
                header={`Summary for ${selectedConcept.concept}`}
                loading={loadingConceptSummary}
                summary={conceptSummary}
            />
            <SummaryDocuments
                header={`Documents for ${selectedConcept.concept}`}
                loading={loadingConceptDocuments}
                documents={conceptDocuments}
            />
        </>
    );
};

export default VolumeSummary;
